import http from '../../../common/axios/axios.instance';
import {
  ENDPOINT_OFFERS_HOME,
  ENDPOINT_OFFERS_GET_ALL,
  ENDPOINT_OFFERS_GET_ONE,
  ENDPOINT_OFFERS_CATEGORIES,
  ENDPOINT_OFFERS_BANNER,
  ENDPOINT_OFFERS_SEARCH,
} from '../endpoints/offers.endpoints';

export const getOffersHomeApi = () => {
  return http.get(ENDPOINT_OFFERS_HOME).then((response) => response.data);
};

export const getOffersListApi = (body) => {
  const { filter, include, limit = 10, index = 0 } = body;
  const params = new URLSearchParams();

  if (filter) params.append('filter', JSON.stringify(filter));
  if (include) params.append('include', JSON.stringify(include));
  params.append('limit', limit);
  params.append('index', index);

  return http
    .get(`${ENDPOINT_OFFERS_GET_ALL}?${params.toString()}`)
    .then((response) => response.data);
};

export const getOffersSearchApi = (body) => {
  const { q, lang, limit = 10, index = 0 } = body || {};
  const params = new URLSearchParams();
  if (q) params.append('q', q);
  if (lang) params.append('lang', lang);
  params.append('limit', limit);
  params.append('index', index);

  return http.get(`${ENDPOINT_OFFERS_SEARCH}?${params.toString()}`).then((response) => response.data);
};

export const getOffersOneApi = (offerId) => {
  return http.get(ENDPOINT_OFFERS_GET_ONE + '/' + offerId).then((response) => response.data);
};

export const getOffersCategoriesApi = () => {
  return http.get(ENDPOINT_OFFERS_CATEGORIES).then((response) => response.data);
};

// export const postOffersSaveFavoritesApi = (offerId) => {
//   return http.post(ENDPOINT_OFFERS_ADD_FAVORITES + '/' + offerId).then((response) => response.data);
// };

// export const postOffersRemoveFavoritesApi = (offerId) => {
//   return http
//     .get(ENDPOINT_OFFERS_REMOVE_FAVORITES + '/' + offerId)
//     .then((response) => response.data);
// };

export const getOfferBannersApi = (body) => {
  const payload = new URLSearchParams({
    filter: JSON.stringify(body),
    sort: JSON.stringify({ order: 1 }),
  }).toString();

  return http.get(`${ENDPOINT_OFFERS_BANNER}?${payload}`).then((response) => response.data);
};

export const saveOfferApi = (offerId) => {
  return http.post(`/api/v1/offers/save/${offerId}`);
};

export const unSaveOfferApi = (offerId) => {
  return http.post(`/api/v1/offers/unsave/${offerId}`);
};
